import rootReducer from 'redux/reducers'
import { applyMiddleware, createStore, compose, Store, AnyAction } from 'redux'
import thunk, { ThunkDispatch } from 'redux-thunk'
import { throttle } from 'libraries/lodash'
import { loadState, saveState } from './sessionStorage'

const sessionState = loadState()
const composeEnhancers = ((window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose | undefined) ?? compose // allows use of https://github.com/zalmoxisus/redux-devtools-extension

const reduxStore: Store = createStore(
  rootReducer,
  sessionState,
  composeEnhancers(
    applyMiddleware(thunk)
  )
)

reduxStore.subscribe(throttle(() => {
  const { dealwatch } = reduxStore.getState()
  saveState({ dealwatch })
}, 500)
)
// TODO: Don't export redux store if Server Side Rendering!
// See --> https://daveceddia.com/access-redux-store-outside-react/#option-1-export-the-store
export default reduxStore

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = typeof reduxStore
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>
export type AppState = ReturnType<typeof reduxStore.getState>
